import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=29593e93&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29593e93",
  null
  
)

export default component.exports